export class EventDetail{
    eventName: string;
    start: Date;
    end: Date;
    body: string;
    venue: string;
    isLink: boolean;
    color: string;
    assessmentlink: string;
    originalstart: Date;
    originalend: Date;
    lessonName:string;
    moduleID:any;
    classId:any;
    /**
     *
     */
    constructor() {
        this.eventName = "";
        this.start = new Date;
        this.end = new Date,
        this.body = "",
        this.venue = "",
        this.isLink = false,
        this.color = "",
        this.originalstart = new Date;
        this.originalend = new Date;
        this.lessonName = "";
        this.moduleID= 0;
        this.classId = 0;
    }
}
